import { RootState } from "../../store";
import { DimensionsState } from "../utils/types/common";

export const dimensionsSliceSelector = (state: RootState): DimensionsState => {
  return state.dimensions;
};
